import type { Census2022Status } from './census-2022-api';

interface Census2022StatusBadgeProps {
  status: Census2022Status;
}

const STATUS_CONFIG: Record<Census2022Status, { label: string; className: string }> = {
  none:             { label: 'No preparado',    className: 'c22-badge c22-badge--none' },
  processing_2022:  { label: 'Procesando',       className: 'c22-badge c22-badge--processing' },
  ready_2022:       { label: 'Listo',            className: 'c22-badge c22-badge--ready' },
  stale_2022:       { label: 'Desactualizado',   className: 'c22-badge c22-badge--stale' },
  error_2022:       { label: 'Error',            className: 'c22-badge c22-badge--error' },
};

export function Census2022StatusBadge({ status }: Census2022StatusBadgeProps): JSX.Element {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG['none'];
  return (
    <span className={config.className}>
      {config.label}
    </span>
  );
}
